import { DIALOG_TYPE, LayoutConfig, SpinnerComponent } from "@spartacus/storefront";
import { GEN_FAVORITES_DIALOGS } from "../enums/favorites-dialogs.enum";
import { GenAddedToCartDialogComponent } from "../features/cart/added-to-cart-dialog/added-to-cart-dialog.component";
import { GenCheckoutDelegoComponent } from "../features/checkout/checkout-delego/checkout-delego.component";
import { GenFFMixedCartDialogComponent } from "../features/checkout/checkout-delivery-address/ff-mixed-cart-dialog/ff-mixed-cart-dialog.component";
import { GenSplitPaymentDialogComponent } from "../features/checkout/checkout-delivery-address/split-payment-dialog/split-payment-dialog.component";
import { GenVerifyAddressComponent } from "../features/checkout/checkout-delivery-address/verify-address/verify-address.component";
import { GenCheckoutOutOfStockDialogComponent } from "../features/checkout/checkout-service-parts/checkout-out-of-stock-dialog/checkout-out-of-stock-dialog.component";
import { GenAddToFavoritesDialogComponent } from "../features/favorites/add-to-favorites-dialog/add-to-favorites-dialog.component";
import { GenCreateOrEditFavoritesListDialogComponent } from "../features/favorites/create-or-edit-favorites-list-dialog/create-or-edit-favorites-list-dialog.component";
import { GenFavoriteProductsAddedToCartDialogComponent } from "../features/favorites/favorite-products-added-to-cart-dialog/favorite-products-added-to-cart-dialog.component";
import { FavoritesConfirmActionDialogComponent } from "../features/favorites/favorites-confirm-action-dialog/favorites-confirm-action-dialog.component";
import { GenDeleteSavedAddressDialogComponent } from "../features/saved-addresses/delete-saved-address-dialog/delete-saved-address-dialog.component";
import { GenEditSavedAddressDialogComponent } from "../features/saved-addresses/edit-saved-address-dialog/edit-saved-address-dialog.component";
import { ContactFactoryDialogComponent } from "../shared/components/contact-factory-dialog/contact-factory-dialog.component";
import { WarningDialogComponent } from "../shared/components/warning-dialog/warning-dialog.component";
import { ClearCartDialogComponent } from "@spartacus/cart/base/components";
import { GenProductImageZoomDialogComponent } from "src/app/generac/features/product/product-image-zoom-product-images/product-image-zoom-trigger/product-image-zoom-dialog/product-image-zoom-dialog.component";
import { GenServicePartsSearchDialogComponent } from "../features/search-box/service-parts-search-dialog/service-parts-search-dialog.component";

export const genLayoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      lg: {
        slots: ['SiteLogo', 'SearchBox', 'QuickOrder', 'SiteLinks', 'SiteLogin', 'MiniCart', 'NavigationBar'],
      },
    },
    navigation: {
      slots: ['SiteLinks', 'SiteLogin', 'NavigationBar', 'QuickOrder'],
    },
    CartPageTemplate: {
      slots: ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent', 'BottomContentSlot'],
    },
    ProductGridPageTemplate: {
      slots: ['ProductLeftRefinements', 'ProductGridSlot', 'PlaceholderContentSlot', 'ProductGridAdditionalSlot'],
    },
    ProductDetailsPageTemplate: {
      lg: {
        pageFold: 'UpSelling',
      },
      pageFold: 'Summary',
      slots: [
        'ProductHeaderMenu',
        'Summary',
        'Bundles',
        'Tabs',
        'ValueComparisonChart',
        'UpSelling',
        'CrossSelling',
        'RecentlyReviewed',
      ],
    },
    BundlesPageTemplate: {
      lg: {
        pageFold: 'UpSelling',
      },
      pageFold: 'Summary',
      slots: [
        'BundleListSlot',
        'PlaceholderContentSlot'
      ],
    },
  },
  launch: {
    ADDED_TO_CART: {
      inlineRoot: true,
      component: GenAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    VERIFY_ADDRESS: {
      inlineRoot: true,
      component: GenVerifyAddressComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    PAY_BY_DELEGO: {
      inlineRoot: true,
      component: GenCheckoutDelegoComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    [GEN_FAVORITES_DIALOGS.ADD_TO_FAVORITES]: {
      inlineRoot: true,
      component: GenAddToFavoritesDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    [GEN_FAVORITES_DIALOGS.CREATE_OR_EDIT_FAVORITES_LIST]: {
      inlineRoot: true,
      component: GenCreateOrEditFavoritesListDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    [GEN_FAVORITES_DIALOGS.FAVORITES_CONFIRM_ACTION]: {
      inlineRoot: true,
      component: FavoritesConfirmActionDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    [GEN_FAVORITES_DIALOGS.FAVORITE_PRODUCTS_ADDED_TO_CART]: {
      inlineRoot: true,
      component: GenFavoriteProductsAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    WARNING_DIALOG: {
      inlineRoot: true,
      component: WarningDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    EDIT_SAVED_ADDRESS: {
      inlineRoot: true,
      component: GenEditSavedAddressDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    DELETE_SAVED_ADDRESS: {
      inlineRoot: true,
      component: GenDeleteSavedAddressDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CONTACT_FACTORY: {
      inlineRoot: true,
      component: ContactFactoryDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CHECKOUT_OUT_OF_STOCK: {
      inlineRoot: true,
      component: GenCheckoutOutOfStockDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CHECKOUT_SPLIT_PAYMENT_DIALOG: {
      inlineRoot: true,
      component: GenSplitPaymentDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CHECKOUT_FF_MIXED_CART_DIALOG: {
      inlineRoot: true,
      component: GenFFMixedCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    PLACE_ORDER_SPINNER: {
      inlineRoot: true,
      component: SpinnerComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CLEAR_CART: {
      inlineRoot: true,
      component: ClearCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    PRODUCT_IMAGE_ZOOM: {
      inlineRoot: true,
      component: GenProductImageZoomDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    SERVICE_PARTS_SEARCH: {
      inlineRoot: true,
      component: GenServicePartsSearchDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
}